<small>{{ 'SupportComponent.text' | translate }}</small
><br />
{{ 'SupportComponent.phone' | translate }}:
<a [href]="config.getSetting('tel_phone')" class="text-bolder">{{ config.getSetting('phone') }}</a>
<span class="d-none d-lg-inline"> | </span><br class="d-block d-lg-none" />
{{ 'SupportComponent.email' | translate }}:
<a [href]="config.getSetting('mailto_email')">{{ config.getSetting('email') }}</a>
